/** Bell track numbers: the file name on the bell's SD card ("0004.mp3"). See docs/BELL_DEVICE.md. */

export const BELL_SEQUENCE_TRACKS = 21;

const ORDINALS = ['الأولى', 'الثانية', 'الثالثة', 'الرابعة', 'الخامسة', 'السادسة'];

const SEQUENCE_LABELS: Record<number, string> = {
  1: 'رسالة بداية اليوم',
  2: 'النشيد المختصر',
  3: 'النشيد الكامل',
  4: 'جرس بداية الحصة',
  5: 'جرس الاستراحة',
  ...Object.fromEntries(
    ORDINALS.flatMap((ord, i) => [
      [6 + i * 2, `بداية الحصة ${ord}`],
      [7 + i * 2, `نهاية الحصة ${ord}`],
    ]),
  ),
  18: 'رسالة الطوارئ',
  19: 'صفارة الطوارئ',
  20: 'انتهاء الطوارئ',
  21: 'شكرًا لتعاونكم',
};

export function trackCode(track: number): string {
  return String(track).padStart(4, '0');
}

export function trackLabel(track: number): string {
  return `${trackCode(track)} — ${SEQUENCE_LABELS[track] ?? 'صوت إضافي'}`;
}
